export default __webpack_public_path__ + "static/media/layout4.0ac83f5b.svg";